<template>
  <div>
    <a-card size="small" title="标签组">
      <a slot="extra" v-has="{ code: 'system:tag:group:add', project: 0 }" @click="onAdd"> <a-icon type="plus" /> 添加 </a>
      <a-skeleton :loading="loading">
        <div v-for="(group, index) in groupList" :key="index">
          <div :class="`${group.id === currentGroup ? 'group-item group-item_active' : 'group-item'}`" @click="onGroup(group.id)">
            <span class="group-item_name">{{ group.name }} {{ group.code ? `( ${group.code} )` : '' }} </span>
            <span v-if="group.id !== null" class="group-item_more">
              <a v-has="{ code: 'system:tag:group:edit', project: 0 }" style="margin: 0 4px" @click.stop="onEdit(group)"><a-icon type="edit" /> </a>
              <a v-has="{ code: 'system:tag:group:delete', project: 0 }" style="margin: 0 4px" @click.stop="onDelete(group.id)"><a-icon type="delete" /> </a>
            </span>
          </div>
        </div>
      </a-skeleton>
    </a-card>
    <group-modal :is-show="visible" :group-id="groupId" :group-data="groupData" @close="close" />
  </div>
</template>

<script>
import { tagGroupList, tagGroupDelete } from '@/api/system/tag';
import GroupModal from '@/pages/system/tags/components/GroupModal';

export default {
  components: { GroupModal },
  data() {
    return {
      loading: true,
      groupTotal: 0,
      groupList: [],
      currentGroup: null,
      groupId: null,
      groupData: {},
      visible: false
    };
  },
  watch: {
    currentGroup() {
      this.$emit('selected', this.currentGroup);
    }
  },
  created() {
    this.getGroupList();
  },
  methods: {
    getGroupList() {
      tagGroupList({})
        .then(res => {
          this.groupList = [{ id: null, name: '全部' }, ...res.data.items];
          this.total = res.data.total;
          if (this.currentGroup === null) {
            this.currentGroup = this.groupList[0].id;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDelete(group_id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这个分组吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          tagGroupDelete({ id: group_id }).then(() => {
            self.$message.success('删除成功');
            self.getGroupList();
          });
        }
      });
    },

    onGroup(group_id) {
      this.currentGroup = group_id;
    },

    onAdd() {
      this.visible = true;
    },

    onEdit(group) {
      this.groupId = group.id;
      this.groupData = {
        code: group.code,
        name: group.name,
        sort: group.sort
      };
      this.visible = true;
    },

    close(type = 'cancel') {
      this.visible = false;
      this.groupId = null;
      this.groupData = {};
      if (type !== 'cancel') {
        this.getGroupList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-card-body) {
  padding: 12px 0;
  overflow-y: auto;
  height: calc(~'100vh - 180px');
}

.group-item {
  position: relative;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 16px;
  overflow: hidden;
}

.group-item_name {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-item_more {
  position: absolute;
  right: 16px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  // background: linear-gradient(to left, #e6f7ff 100%, rgba(255, 255, 255, 0));
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  font-weight: bold;
}

.group-item:hover .group-item_more,
.group-item_active .group-item_more {
  opacity: 1;
  pointer-events: auto;
}

.group-item:hover,
.group-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}
</style>
